import { render, staticRenderFns } from "./proofPasswordGateModal.vue?vue&type=template&id=940da3b2&scoped=true&"
import script from "./proofPasswordGateModal.vue?vue&type=script&lang=js&"
export * from "./proofPasswordGateModal.vue?vue&type=script&lang=js&"
import style0 from "./proofPasswordGateModal.vue?vue&type=style&index=0&id=940da3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940da3b2",
  null
  
)

export default component.exports